import { useMutation } from "@tanstack/react-query";
import { useChatContext } from "stream-chat-react";
import { postChatChannelChannelIdAccept } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: (error: unknown) => void;
};

export const useAcceptChatChannelMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const { client } = useChatContext();

  return useMutation<void, unknown, string>({
    mutationFn: processResponseWithApiProblemDetails((channelId: string) =>
      postChatChannelChannelIdAccept(channelId),
    ),
    onSuccess: async (_data, channelId) => {
      await client.channel("messaging", channelId).query({});
      onSuccess?.();
    },
    onError,
  });
};
